<template>
    <div class="about">
        <div class="difficult">
            <div class="difficult-cen">
                <h1>专业团队倾力<span style="color: #2B77FF;">解决行业难题</span></h1>
                <p>专注制造行业数字化解决方案与云服务，为制造业提供一站式端到端数字化</p>
            </div>
        </div>

        <div class="aboutUs">
            <div class="aboutUs-cen">
                <div class="aboutUs-top clearfloat">
                    <h2>ABOUT</h2>
                    <ul class="clearfloat">
                        <li class="aboutUs-active">公司简介</li>
                        <li @click="clickDevelop">发展历程</li>
                        <li @click="clickCulture">公司文化</li>
                    </ul>
                </div>
                <p>关于我们</p>
                <div class="aboutUs-content">
                    <div>
                        <img src="../assets/about/12.png" alt="">
                        <div>
                            <h3>浙江理业科技有限公司</h3>
                            <p style="margin-bottom: 54px;">成立于2018年，公司地址位于中国浙江省丽水市莲都区。我们是一家致力于为离散型中小型制造企业提供数字
                                化服务的高科技公司。</p>
                            <h3>理业数智管理系统</h3>
                            <p>理业数智管理系统是专门为阀门制造行业定制的ERP系统。理业管理系统具有全面的业务管理功能，高度定制</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="develop" ref="developSection">
            <div class="develop-cen">
                <div class="develop-pos">
                    <h2>ABOUT</h2>
                    <P>发展历程</P>
                </div>
                <div class="develop-content" v-show="currentIndex == 0">
                    <div class="develop-left">
                        <h3>2018</h3>
                        <p>公司正式成立</p>
                        <span>浙江丽水逆熵科技公司成立</span>
                    </div>
                    <div class="develop-right">
                        <img src="../assets/about/01.png" alt="">
                    </div>
                </div>
                <div class="develop-content" v-show="currentIndex == 1">
                    <div class="develop-left">
                        <h3>2019</h3>
                        <p>理业管理系统v1.0版本上线</p>
                        <span>在阀毕威等多个阀门公司使用</span>
                    </div>
                    <div class="develop-right">
                        <img src="../assets/about/02.png" alt="">
                    </div>
                </div>
                <div class="develop-content" v-show="currentIndex == 2">
                    <div class="develop-left">
                        <h3>2020</h3>
                        <p>系统全面升级</p>
                        <span>理业管理系统v2.0版本上线</span>
                    </div>
                    <div class="develop-right">
                        <img src="../assets/about/03.png" alt="">
                    </div>
                </div>
                <div class="develop-content" v-show="currentIndex == 3">
                    <div class="develop-left">
                        <h3>2021</h3>
                        <p>东莞逆熵电子科技成立，</p>
                        <span>进一步拓展项目研发及业务开拓</span>
                    </div>
                    <div class="develop-right">
                        <img src="../assets/about/04.png" alt="">
                    </div>
                </div>
                <div class="develop-content" v-show="currentIndex == 4">
                    <div class="develop-left">
                        <h3>2022</h3>
                        <p>与华为强强联合</p>
                        <span>与华为进行数控机联数据采集项目联合研发</span>
                    </div>
                    <div class="develop-right">
                        <img src="../assets/about/05.png" alt="">
                    </div>
                </div>
                <div class="container">
                    <div class="arrow-left"></div>
                    <div class="line">
                        <div class="circle " @click="showContent(0)" :class="{ 'circleActive': currentIndex === 0 }"
                            style="left: 10%;"></div>
                        <div class="circle" @click="showContent(1)" :class="{ 'circleActive': currentIndex === 1 }"
                            style="left: 30%;"></div>
                        <div class="circle" @click="showContent(2)" :class="{ 'circleActive': currentIndex === 2 }"
                            style="left: 50%;"></div>
                        <div class="circle" @click="showContent(3)" :class="{ 'circleActive': currentIndex === 3 }"
                            style="left: 70%;"></div>
                        <div class="circle" @click="showContent(4)" :class="{ 'circleActive': currentIndex === 4 }"
                            style="left: 90%;"></div>
                    </div>
                    <div class="arrow-right"></div>
                </div>
            </div>
        </div>

        <div class="culture" ref="cultureSection">
            <div class="culture-cen">
                <div class="culture-pos">
                    <h2>ABOUT</h2>
                    <P>公司文化</P>
                </div>
                <div class="culture-content">
                    <div @mouseover="showContent1(0)" :class="{ 'culture-active': currentIndex1 === 0 }">
                        <h3>专业/专注</h3>
                        <p>我们的团队年轻精炼、充满活力、富有创造力。他们有着丰富的制造业经验和技术储备，能够为客户提供专业的咨询和服务。</p>
                        <div>
                            <img src="../assets/product/control1.png" alt="">
                        </div>
                    </div>
                    <div @mouseover="showContent1(1)" :class="{ 'culture-active': currentIndex1 === 1 }">
                        <h3>创新/进取</h3>
                        <p>通过持续的创新，我们不仅提升了产品的竞争力，更推动了行业的发展。我们的创新精神让每一个项目都充满无限可能。</p>
                        <div>
                            <img src="../assets/product/control1.png" alt="">
                        </div>
                    </div>
                    <div @mouseover="showContent1(2)" :class="{ 'culture-active': currentIndex1 === 2 }">
                        <h3>效率/规范</h3>
                        <p>我们的团队严格遵循行业标准和操作规范。通过优化流程和提升工作效率，我们能够快速响应客户需求，提供高质量的产品和服务，帮助客户实现业务目标。</p>
                        <div>
                            <img src="../assets/product/control1.png" alt="">
                        </div>
                    </div>
                    <div @mouseover="showContent1(3)" :class="{ 'culture-active': currentIndex1 === 3 }">
                        <h3>开发/协同</h3>
                        <p>通过紧密协作和高效沟通，实现无缝衔接和高效开发。我们都秉持协同合作的理念，共同推动项目的顺利进行，确保每一个产品都能超越客户期望。</p>
                        <div>
                            <img src="../assets/product/control1.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'productPrice',
    data() {
        return {
            currentIndex: 0,
            currentIndex1: 0,
            intervalId: null
        }
    },
    methods: {
        showContent(index) {
            this.currentIndex = index;
        },
        startCarousel() {
            this.intervalId = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % 5; // Assuming there are 3 items
            }, 5000); // Change every 3 seconds
        },
        stopCarousel() {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        },
        showContent1(index) {
            this.currentIndex1 = index;
        },
        clickDevelop() {
            this.$nextTick(() => {
                this.$refs.developSection.scrollIntoView({ behavior: 'smooth' });
            });
        },
        clickCulture() {
            this.$nextTick(() => {
                this.$refs.cultureSection.scrollIntoView({ behavior: 'smooth' });
            });
        },
    },
    mounted() {
        this.startCarousel();
    },
    beforeDestroy() {
        this.stopCarousel();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about {
    background: #fff;
}

.difficult {
    background: url(../assets/about/11.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    height: 522px
}

.difficult-cen,
.aboutUs-cen,
.develop-cen,
.culture-cen {
    width: 1460px;
    margin: 0 auto;
}

.difficult-cen {
    padding-top: 148px;
}

.difficult-cen h1 {
    font-weight: bold;
    font-size: 70px;
    color: #3F3F3F;
    font-style: normal;
    margin-bottom: 16px;
}

.difficult-cen p {
    font-weight: 400;
    font-size: 18px;
    color: #3F3F3F;
}

.aboutUs-cen {
    padding-top: 80px;
    padding-bottom: 80px;
}

.aboutUs-cen>p {
    font-weight: 600;
    font-size: 24px;
    color: #3F3F3F;
    line-height: 50px;
    margin-bottom: 24px;
}

.aboutUs-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.aboutUs-top h2 {
    font-weight: 600;
    font-size: 36px;
    color: #3F3F3F;
}

.aboutUs-top ul {}

.aboutUs-top ul li {
    font-weight: 400;
    font-size: 22px;
    color: #3F3F3F;
    cursor: pointer;
    float: left;
    margin-left: 40px;
    padding-bottom: 2px;
}

.aboutUs-top ul .aboutUs-active {
    color: #2B77FF;
    border-bottom: 1px solid#2B77FF;
}

.aboutUs-content>div {
    display: flex;
}

.aboutUs-content>div>div {
    height: 494px;
    background: #fff;
    padding: 80px 62px 0 62px;
}

.aboutUs-content>div>div h3 {
    font-weight: 600;
    font-size: 22px;
    color: #3F3F3F;
    margin-bottom: 34px;
}

.aboutUs-content>div>div p {
    font-weight: 400;
    font-size: 20px;
    color: #3F3F3F;
    line-height: 32px
}

.develop {
    background: url(../assets/about/000.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    background-color: rgb(192 163 209, .7);
    height: 618px;
    padding-top: 84px;
    box-sizing: border-box;
}

.develop-cen {
    position: relative;
}

.develop-cen .develop-pos {
    font-weight: 600;
    color: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0
}

.develop-cen .develop-pos h2 {
    font-size: 36px;
    margin-bottom: 8px;
}

.develop-cen .develop-pos p {
    font-size: 24px;
}

.develop-content {
    width: 1042px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: #fff
}

.develop-content h3 {
    width: 132px;
    height: 48px;
    font-size: 24px;
    line-height: 48px;
    border: 2px solid #FFFFFF;
    text-align: center;
}

.develop-content p {
    font-size: 22px;
    color: #FFFFFF;
    margin-top: 68px;
    margin-bottom: 16px;
}

.develop-content span {
    font-weight: 400;
    font-size: 20px;
}

.container {
    display: flex;
    align-items: center;
    width: 1452px;
    position: relative;
    margin-top: 90px
}

.arrow-left,
.arrow-right {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid #fff;
}

.arrow-right {
    transform: rotate(180deg);
}

.line {
    flex-grow: 1;
    height: 1px;
    background-color: #fff;
    position: relative;
}

.circle {
    width: 16px;
    height: 16px;
    border: 1px solid #fff;
    background: rgb(141 170 222);
    z-index: 123;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
}

.circleActive {
    background: #ddd;
}



.culture {
    height: 814px;
    padding-top: 78px;
    box-sizing: border-box;
}

.culture-cen {
    position: relative;
}

.culture-cen .culture-pos {
    font-weight: 600;
    color: #3F3F3F;
}

.culture-cen .culture-pos h2 {
    font-size: 36px;
    margin-bottom: 8px;
}

.culture-cen .culture-pos p {
    font-size: 24px;
}

.culture-content {
    display: flex;
    justify-content: space-between;
    width: 1151px;
    margin: 88px auto 0
}

.culture-content>div {
    width: 210px;
    height: 356px;
    background: #FFFFFF;
    padding-top: 50px;
    box-sizing: border-box;
    box-shadow: 0 2px 15px rgb(187 186 186 / 30%);
    cursor: pointer;
    transition: width .8s
}

.culture-content>div h3 {
    font-size: 24px;
    color: #3F3F3F;
    text-align: center;
}

.culture-content>div p {
    display: none;
}

.culture-content>div>div {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #DBE8FF;
    margin: 174px auto 0;
    text-align: center;
}

.culture-content .culture-active {
    background: url(../assets/about/14.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 466px;
    height: 356px;
    padding: 44px 38px 0;
    box-sizing: border-box;
    color: #FFFFFF;
    transition: width .8s
}

.culture-content .culture-active h3 {
    font-size: 24px;
    color: #FFFFFF;
}

.culture-content .culture-active p {
    font-size: 20px;
    line-height: 34px;
    margin-top: 50px;
    display: block
}

.culture-content .culture-active div {
    display: none;
}

.culture-content .culture-active img {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue